/**
 * Helpers for the anonymous "explore without signing up" flow.
 *
 * An anonymous user is created via POST /api/v1/onboarding/anonymous-start and
 * carries an `anonymous: true` JWT claim plus `is_anonymous: true` on the
 * stored user record. They explore on a throwaway workspace until they "claim"
 * it by verifying a real email.
 */
import { getToken, parseJwt } from './auth';

export function isAnonymousUser(): boolean {
  // Prefer the stored user record; fall back to the JWT `anonymous` claim.
  try {
    const raw = window.localStorage.getItem('klaris_user');
    if (raw) {
      const u = JSON.parse(raw);
      if (typeof u?.is_anonymous === 'boolean') return u.is_anonymous;
    }
  } catch {
    /* ignore */
  }
  const token = getToken();
  if (token) {
    const payload = parseJwt(token);
    if (payload && typeof payload.anonymous === 'boolean') return Boolean(payload.anonymous);
  }
  return false;
}
